import side_photo from "../assets/images/side_splash.jpg"

const home = {
  photo: "https://media.giphy.com/media/Y4ak9Ki2GZCbJxAnJD/giphy.gif",
  side_photo: side_photo,
  sub_greeting: "Edward,",
  info_1: "Frontend Developer",
  info_2: "Backend Developer",
  info_3: "Full Stack Developer",
};

export { home };
